import { render, staticRenderFns } from "./CardDashboardHabitsTracker.vue?vue&type=template&id=c0960318"
import script from "./CardDashboardHabitsTracker.vue?vue&type=script&lang=js"
export * from "./CardDashboardHabitsTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports